var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid grid-cols-1 lg:grid-cols-3  gap-24 lg:gap-[50px] " },
    [
      _c("div", { staticClass: "lg:absolute right-24 top-0" }, [
        _c(
          "h3",
          { staticClass: "text-brown-400 mb-16 lg:mb-24 font-bold text-35" },
          [_vm._v("Zoeken in veelgevaagd:")]
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.search,
              expression: "search"
            }
          ],
          staticClass:
            "rounded-4 bg-white focus:outline-none h-[62px] w-full md:w-[500px] px-24",
          attrs: { type: "search", placeholder: "Geef jouw zoektermen in" },
          domProps: { value: _vm.search },
          on: {
            input: [
              function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.search = $event.target.value
              },
              _vm.handleSearch
            ]
          }
        })
      ]),
      _vm._v(" "),
      _vm.loading
        ? _c(
            "div",
            {
              staticClass:
                "lg:col-span-3 flex flex-wrap p-75 items-center justify-center"
            },
            [_c("loader", { staticClass: "h-50", attrs: { loading: true } })],
            1
          )
        : _vm.async || _vm.search !== ""
        ? [
            _vm.single
              ? _vm._l(_vm.computedCategories, function(c) {
                  return _c(
                    "div",
                    { key: c.id, staticClass: "bg-white p-24 lg:p-[50px]" },
                    [
                      _c(
                        "div",
                        _vm._l(c, function(f) {
                          return _c(
                            "a",
                            {
                              key: f.id,
                              staticClass:
                                "flex items-center gap-8 flex-row text-orange group pb-16 mb-16 border-b border-gray-200 w-full justify-between",
                              attrs: { href: f.link }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(f.title.rendered) +
                                  "\n            "
                              ),
                              _c("i", {
                                staticClass:
                                  "fas fa-chevron-right text-14 text-black group-hover:mr-[-8px] transition-all"
                              })
                            ]
                          )
                        }),
                        0
                      )
                    ]
                  )
                })
              : _vm._l(_vm.computedCategories, function(c) {
                  return _c(
                    "div",
                    { key: c.id, staticClass: "bg-white p-24 lg:p-[50px]" },
                    [
                      _c("h4", {
                        staticClass: "text-30 font-regular mb-24",
                        domProps: { innerHTML: _vm._s(c.name) }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _vm._l(c.faqs, function(f) {
                            return _c(
                              "a",
                              {
                                key: f.id,
                                staticClass:
                                  "flex items-center gap-8 flex-row text-orange group pb-16 mb-16 border-b border-gray-200 w-full justify-between",
                                attrs: { href: f.link }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(f.title.rendered) +
                                    "\n            "
                                ),
                                _c("i", {
                                  staticClass:
                                    "fas fa-chevron-right text-14 text-black group-hover:mr-[-8px] transition-all"
                                })
                              ]
                            )
                          }),
                          _vm._v(" "),
                          !_vm.single
                            ? _c(
                                "a",
                                {
                                  staticClass:
                                    "faq text-white bg-orange rounded-full text-20  mt-16 inline-block py-[14px] px-24 hover:opacity-75 transition-opacity",
                                  attrs: {
                                    "data-faq-category": c.name,
                                    href: "/faq/category/" + c.slug
                                  }
                                },
                                [_vm._v("bekijk alle vragen")]
                              )
                            : _vm._e()
                        ],
                        2
                      )
                    ]
                  )
                })
          ]
        : [_vm._t("default")]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }